import React, { useState, useEffect, useContext } from 'react';
import BuildRatio from '../progressBars/buildRatio';
import ProgressCircle from '../progressBars/circle';
import ImgTooltip from '../pokemonImg/imgTooltip';
import Axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { AppConfigContext, axios_timeout } from '../../Config/App';
import { getUserFromLocalStorage } from '../../utils/localStorage';
import uuid from 'uuidv4';
import { LanguageContext } from '../../Data/Context/languageContext';
import { useInView } from 'react-intersection-observer';
import BtnRounded from '../btn/btnRounded';

const UserBuilds = () => {
    const { api_url, assets_url, navigate_to } = useContext(AppConfigContext);
    const [builds, setBuilds] = useState([]);
    const navigate = useNavigate();
    const user_session = getUserFromLocalStorage();
    const { t } = useContext(LanguageContext);

    const { ref: endOfPage, inView: isEndOfPage } = useInView({ rootMargin: '0px 0px 600px 0px' });

    const offset = 7;
    const [limit, setLimit] = useState(offset);
    const [userNumBuilds, setUserNumBuilds] = useState();
    const [canFetch, setCanFetch] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (canFetch === true) if (!isEndOfPage && limit) setLimit(limit + offset);

        if (limit !== offset)
            Axios.get(api_url(`users-builds/${user_session.user_id}/${limit}`), {
                timeout: axios_timeout,
            })
                .then((response) => {
                    if (response.status === 200) setBuilds(response.data);

                    if (limit >= userNumBuilds) setCanFetch(false);
                })
                .catch((err) => {
                    console.log(err.code, err.stack, err.message);
                });

        // eslint-disable-next-line
    }, [isEndOfPage]);

    useEffect(() => {
        if (canFetch)
            Axios.get(api_url(`users-builds/${user_session.user_id}`), { timeout: axios_timeout })
                .then((response) => {
                    if (response.status === 200) setUserNumBuilds(response.data.num_builds);
                })
                .catch((err) => {
                    console.log(err.code, err.stack, err.message);
                });

        setIsLoaded(true);
        // eslint-disable-next-line
    }, []);

    return (
        <div
            className='col'
            id='user-builds-list'>
            <div className='row'>
                {builds && isLoaded && builds.length > 0 ? (
                    builds.map((build) => {
                        return (
                            <div
                                key={uuid()}
                                onClick={() => navigate(navigate_to(`dashboard/build/edit/${build.id}`))}
                                className='build-info mb-3 custom-border rounded-3 py-1'>
                                <div className='row my-2'>
                                    <div className='col-12 col-sm-7 col-md-6 col-lg-7 col-xxl-5 d-flex justify-content-center justify-content-sm-start align-items-center'>
                                        <div className='d-none d-sm-flex'>
                                            <BuildRatio
                                                likes={+build.likes}
                                                dislikes={+build.dislikes}
                                            />
                                        </div>
                                        <ProgressCircle
                                            likes={+build.likes}
                                            dislikes={+build.dislikes}>
                                            <img
                                                loading='lazy'
                                                className='pokemon-ratio-img'
                                                src={assets_url('pokedex/thumbnails/' + build.picture)}
                                                alt={'Pokeland Legends ' + build.name}></img>
                                        </ProgressCircle>
                                        <div id='build-info'>
                                            <p className='mb-1'>
                                                {build.title ? build.title : build.name}
                                                <img
                                                    className='name-flag'
                                                    src={assets_url(`flags/${build.version}.webp`)}
                                                    alt='Pokeland Legends Builder'></img>
                                            </p>
                                            <p>
                                                {t('created_at')}: {build.created_at.split('T')[0]}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-3 d-flex flex-sm-column align-items-center justify-content-center ms-md-auto my-2 my-sm-0'>
                                        {build.teammate_1 ||
                                        build.teammate_2 ||
                                        build.teammate_3 ||
                                        build.teammate_4 ? (
                                            <>
                                                <div className='me-3 me-sm-0'>
                                                    {build.teammate_1 && (
                                                        <ImgTooltip
                                                            classes='team-mate-border border-small m-1 img-fluid'
                                                            src={assets_url('pokedex/thumbnails/') + build.teammate_1}
                                                            alt={'Pokeland Legends ' + build.name}></ImgTooltip>
                                                    )}
                                                    {build.teammate_2 && (
                                                        <ImgTooltip
                                                            classes='team-mate-border border-small m-1 img-fluid'
                                                            src={assets_url('pokedex/thumbnails/') + build.teammate_2}
                                                            alt={'Pokeland Legends ' + build.name}></ImgTooltip>
                                                    )}
                                                </div>
                                                <div>
                                                    {build.teammate_3 && (
                                                        <ImgTooltip
                                                            classes='team-mate-border border-small m-1 img-fluid'
                                                            src={assets_url('pokedex/thumbnails/') + build.teammate_3}
                                                            alt={'Pokeland Legends ' + build.name}></ImgTooltip>
                                                    )}
                                                    {build.teammate_4 && (
                                                        <ImgTooltip
                                                            classes='team-mate-border border-small m-1 img-fluid'
                                                            src={assets_url('pokedex/thumbnails/') + build.teammate_4}
                                                            alt={'Pokeland Legends ' + build.name}></ImgTooltip>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            <p className='mb-0'>{t('no_teammates')}</p>
                                        )}
                                    </div>

                                    <div className='d-flex d-sm-none'>
                                        <BuildRatio
                                            likes={+build.likes}
                                            dislikes={+build.dislikes}
                                        />
                                    </div>

                                    <div className='d-none d-sm-flex col-12 col-sm-2 d-flex flex-sm-column align-items-center justify-content-center ms-md-auto'>
                                        <span className='m-1'>
                                            <i className='fa-solid fa-thumbs-up'></i> {+build.likes}{' '}
                                        </span>
                                        <p className='m-1'>{t('votes')}</p>
                                        <span className='m-1'>
                                            <i className='fa-solid fa-thumbs-down'></i> {+build.dislikes}{' '}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <>
                        <div className='col-12 col-sm-10 col-md-6 col-lg-8 col-xl-6 mx-auto text-center'>
                            <img
                                loading='lazy'
                                className='img-fluid'
                                src={assets_url('no-builds.webp')}
                                alt='Pokeland Legends'></img>
                            <Link to={navigate_to('new-build')}>
                                <BtnRounded classes={'mt-4'}>{t('create_build_dashboard')}</BtnRounded>
                            </Link>
                        </div>
                    </>
                )}
                <div ref={endOfPage}></div>
            </div>
        </div>
    );
};
export default UserBuilds;
